import React, { useEffect, useState } from "react";

const womensLeadershipData = [
  {
    stage: "MA Women Leadership Studies (30 ECTS)",
    modules: [
      {
        title: "Approaching Women’s Studies (3 ECTS)",
        description: `Explore foundational feminist theories & frameworks shaping women’s studies, 
        gender roles, & leadership in diverse societies.`,
      },
      {
        title: "Gender & Development (3 ECTS)",
        description: `Critically examine gender’s influence on global development initiatives & 
        policies, exploring frameworks for sustainable & equitable change. 
        Delve into the historical evolution of gender across Europe, Asia, & Africa 
        to uncover the roots of contemporary societal structures & inequalities. 
        This module equips you with the tools to address pressing gender-related 
        challenges in development & foster transformative solutions.`,
      },
      {
        title: "Gender & Migration (3 ECTS)",
        description: `Examine gendered migration trends, legal frameworks, & sociopolitical 
        implications influencing global population movements & diaspora communities.`,
      },
      {
        title: "Gender, Sexuality, & Law (3 ECTS)",
        description: `Investigate legal systems, theories, & methodologies shaping global gender 
        & sexuality dynamics through critical & interdisciplinary lenses.`,
      },
      {
        title: "Introduction to Qualitative Methods & Data Analysis (3 ECTS)",
        description: `Master qualitative research techniques to collect, analyse, & interpret data 
        for impactful gender-focused academic & practical projects.`,
      },
      {
        title: "Feminist Research Methodologies (3 ECTS)",
        description: `Gain comprehensive skills in feminist research design, ethical considerations, 
        & innovative methodologies for transformative gender studies.`,
      },
      {
        title: "Dissertation (12 ECTS)",
        description: `• Research proposal
• Dissertation (6000 words)`,
      },
    ],
  },
];

const GenderLeadershipModules = () => {
  const [activeStages, setActiveStages] = useState([0]); 
  const [openModuleIndex, setOpenModuleIndex] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleShowStage = (index) => {
    setActiveStages((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });

    if (isMobile) {
      setTimeout(() => {
        const stageEl = document.getElementById(`stage-${index}`);
        if (stageEl) {
          stageEl.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  const toggleModuleDetails = (stageIndex, modIndex) => {
    setOpenModuleIndex((prev) => ({
      ...prev,
      [stageIndex]: prev[stageIndex] === modIndex ? null : modIndex,
    }));
  };

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="modules">
      <div className="max-w-6xl mx-auto p-3 flex flex-col items-center">
        <h2 className="text-center text-2xl font-bold pb-4 border-b-4 border-sdorange inline-block mx-auto">
          Programme Modules
        </h2>

        <div className="sticky md:top-44 top-16 mt-2 flex justify-center my-4">
          <div className="bg-blue-100 border-2 border-blue-500 p-2 rounded-md space-x-4">
            {womensLeadershipData.map((stageData, idx) => (
              <button
                key={idx}
                onClick={() => handleShowStage(idx)}
                className="bg-sddarkorange text-white py-1 px-2 rounded text-sm"
              >
                {stageData.stage}
              </button>
            ))}
          </div>
        </div>

        <div
          className={
            isMobile
              ? "space-y-6" // mobile: vertical
              : "flex space-x-6 overflow-x-auto" // desktop: horizontal
          }
        >
          {activeStages.map((stageIndex) => {
            const { stage, modules } = womensLeadershipData[stageIndex];

            return (
              <div
                key={stageIndex}
                id={`stage-${stageIndex}`}
                className="min-w-[300px] scroll-mt-44 max-w-sm border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4"
              >
                <h3 className="text-xl font-semibold mb-2">{stage}</h3>

                {modules.map((mod, modIndex) => {
                  const isOpen = openModuleIndex[stageIndex] === modIndex;
                  return (
                    <div key={modIndex} className="mb-3">
                      <button
                        onClick={() =>
                          toggleModuleDetails(stageIndex, modIndex)
                        }
                        className="flex justify-between items-center w-full px-2 py-1 bg-sdorange rounded text-gray-700 hover:bg-orange-400 hover:text-black"
                      >
                        <div className="flex items-center space-x-2">
                          <img
                            src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                            alt="Play Icon"
                            className="h-4 w-4"
                          />
                          <span className="font-semibold text-sm">
                            {mod.title}
                          </span>
                        </div>
                        <span>
                          {isOpen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 15l7-7 7 7"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          )}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="mt-2 p-2 bg-sdbodywhite rounded shadow text-sm text-gray-700">
                          <p>{mod.description}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GenderLeadershipModules;
